import React, {ReactNode} from 'react';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {ListConfigNamedColumn} from '@src/@types/components/List';
import {IListConfigColumn} from '@src/@interfaces/components/List/IListConfigColumn';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import {joinArrayOfReactNodes} from '@src/helpers/joinArrayOfReactNodes';

type Column = ListConfigNamedColumn<IListConfigColumn>;

export default class ListColumn<
        Config extends Column = Column,
        Model extends IEmptyModel = IEmptyModel
> extends React.Component<IListColumnProps<Config, Model>> {
    render(): ReactNode {
        return <>{this.processValue(this.value) ?? this.renderEmptyColumn()}</>;
    }

    protected renderEmptyColumn() {
        return '—';
    }

    protected get value(): any | null {
        if (this.props.forceValue !== undefined) {
            return this.props.forceValue;
        }

        const field = (this.config.valueFrom ?? this.config.name) as keyof Model;
        const model = this.model;

        return field in model ? model[field] : null;
    }

    protected processValue(value: any) {
        return this.formatString(value);
    }

    protected formatString(value: any): any {
        if (value != null && typeof value === 'string') {
            return joinArrayOfReactNodes(value.split('\n'), <br/>);
        }

        return value;
    }

    protected get model() {
        return this.props.model;
    }

    protected get config() {
        return this.props.config;
    }

    protected get listConfig() {
        return this.props.listConfig;
    }
}
